import loadable from '@loadable/component'

export const Popup = loadable(() => import('./Popup'))
export type { PopupProps } from './Popup'
